import React from 'react'
import WishlistContainer from '../../../../Components/Apps/ECommerce/Wishlist'

export default function Wishlist() {
  return (
    <div className='page-body'>
        <WishlistContainer/>
    </div>
  )
}
